var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.818,
    height: 101.818,
    viewBox: "0 0 101.818 101.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(-1081.091 -91.091)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_440",
    "data-name": "Grupo 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_1127",
    d: "M1135.443 115.23c10.076 0 16.919 5.941 16.919 15.716 0 10.6-7.519 15.265-17.6 15.265l-.3 5.94h-7.444l-.376-11.806h2.481c8.5 0 15.039-1.5 15.039-9.4 0-5.263-3.233-8.5-8.647-8.5-5.339 0-8.722 3.008-8.722 8.271h-8.046c-.072-9.094 6.47-15.486 16.696-15.486zm-4.812 53.54a5.49 5.49 0 115.414-5.49 5.425 5.425 0 01-5.414 5.49z",
    "data-name": "Trazado 1127"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_120",
    cx: 48,
    cy: 48,
    r: 48,
    "data-name": "Elipse 120",
    transform: "translate(1084 94)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "5.818px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.bb113ff59bc61399f9a1d6c0ded13ffb.svg";
export { ForwardRef as ReactComponent };